import type { ColumnDef } from '@tanstack/react-table';
import { ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ManagedDataTable } from '@/design-system';
import type { Subscription } from '@/features/subscriptions';
import { STATUS_CLASS, STATUS_LABEL, formatSubscriptionDate } from '@/features/subscriptions/utils/subscription-format';

const INTERVAL_LABELS: Record<string, string> = {
  month: 'Mensal', monthly: 'Mensal', semester: 'Semestral', year: 'Anual', yearly: 'Anual',
};
const columns: ColumnDef<Subscription>[] = [
  { id: 'company', header: 'Empresa', accessorFn: (subscription) => subscription.company?.name ?? 'Empresa não informada' },
  { id: 'plan', header: 'Plano', accessorFn: (subscription) => subscription.plan?.name ?? 'Plano não informado' },
  {
    id: 'status', header: 'Status',
    accessorFn: (subscription) => STATUS_LABEL[subscription.status],
    cell: ({ row }) => (
      <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_CLASS[row.original.status]}`}>
        {STATUS_LABEL[row.original.status]}
      </span>
    ),
  },
  { id: 'interval', header: 'Recorrência', accessorFn: (subscription) => INTERVAL_LABELS[subscription.plan?.interval ?? ''] ?? '—' },
  { accessorKey: 'createdAt', header: 'Criada em', cell: ({ row }) => formatSubscriptionDate(row.original.createdAt) },
];
interface DashboardRecentSubscriptionsProps {
  subscriptions: Subscription[];
  isLoading: boolean;
}
export function DashboardRecentSubscriptions({ subscriptions, isLoading }: DashboardRecentSubscriptionsProps) {
  const navigate = useNavigate();
  return (
    <ManagedDataTable
      title="Assinaturas recentes"
      columns={columns}
      data={subscriptions}
      getRowId={(subscription) => subscription.id}
      searchPlaceholder="Buscar empresa, plano ou status..."
      loading={isLoading}
      showPagination={false}
      stickyHeader
      emptyMessage="Nenhuma assinatura encontrada."
      toolbarButtons={[{
        label: 'Ver empresas', icon: <ArrowUpRight size={16} />, variant: 'subtle',
        onClick: () => navigate('/companies'),
      }]}
    />
  );
}
